import React, { useEffect, useState } from 'react'
import facebook from '../../assets/images/blog/facebook.svg'
import twitter from '../../assets/images/blog/twitter.svg'
import linkedin from '../../assets/images/blog/linkedin.svg'
import pinterest from '../../assets/images/blog/pinterest-brands.svg'
import styles from './BlogEntry.module.css'
import './BlogEntry.css'
import MoreEntries from './MoreEntries/MoreEntries'
import LoaderPage from '../Loader/LoaderPage/LoaderPage'
import { head } from 'lodash'

const options = {
  method: 'get',
  headers: new Headers({
    'Content-Type': 'application/x-www-form-urlencoded'
  })
}

const textButton = '¿Quieres ver más antes y despúes?'

const BlogEntry = ({ match }) => {
  const [blogContent, setBlogContent] = useState({})
  const [otherBlogs, setOtherBlogs] = useState({})
  const [isButton, setIsButton] = useState(false)

  const { slug } = match.params
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL_BLOG_API}entry/${slug}`,
    options).then(response => response.json().then(data => ({
      data,
      status: response.status
    })).then(res => {
      if (res && res.data) {
        const ogDescription = window.document.getElementById('og-description')
        ogDescription.setAttribute('content', res.data.summary)

        const description = window.document.getElementById('description')
        description.setAttribute('content', res.data.summary)

        const headerTitle = `${res.data.title}`
        const ogTitle = window.document.getElementById('og-title')
        ogTitle.setAttribute('content', headerTitle)

        const title = window.document.getElementById('maintitle')
        title.innerHTML = headerTitle

        const image = window.document.getElementById('og-image')
        image.setAttribute('content', res.data.coverImage)

        setBlogContent(res.data)
        if (slug === 'muro-de-la-fama-moons-mariana-sabau'){
          setIsButton(true)
        }
      }
    }))

    fetch(`${process.env.REACT_APP_BASE_URL_BLOG_API}list?limit=4&country=mx`,
    options).then(response => response.json().then(data => ({
      data,
      status: response.status
    })).then(res => {
      setOtherBlogs(res.data)
    }))
  }, [setBlogContent, slug])

  if (blogContent.length === 0) {
    return (
      <LoaderPage />
    )
  } if (blogContent.status === 404) {
    return (
      <div className={styles.notFoundContainer}>
        {blogContent.detail}
      </div>
    )
  }
  const newOthers = {}
  if (otherBlogs.entries) {
    newOthers.entries = otherBlogs.entries.filter(item => item.slug !== blogContent.slug)
    if (newOthers.entries.length === 4) {
      newOthers.entries.splice(3, 1)
    }
  }

  const title = blogContent.subTitle ? `${blogContent.title} ${blogContent.subTitle}` : blogContent.title
  const { href, origin } = window.location
  const twitterShare = `http://www.twitter.com/share?url=${href}`
  const linkedInShare = `http://www.linkedin.com/shareArticle?mini=true&url=${href}&title=${title}&summary=${blogContent.summary}&source=${origin}`
  const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${href}&t=${title}`
  const pinterestShare = `https://www.pinterest.com.mx/welovemoons/antes-y-despu%C3%A9s-moons-libera-tu-sonrisa/`
  return (
    <div className={styles.mainContainer}>
      <div className={styles.blogContainer}>
        <div className={styles.title}>
          <div>{blogContent.title}</div>
          {blogContent.subTitle && <div>{blogContent.subTitle}</div>}
        </div>
        <div className={styles.summary}>{blogContent.summary}</div>
        <div className={styles.socialContainer}>
          <a
            href={twitterShare}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.socialIcon}
              src={twitter}
              alt="twitter"
            />
          </a>
          <a
            href={linkedInShare}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.socialIcon}
              src={linkedin}
              alt="linkedin"
            />
          </a>
          <a
            href={facebookShare}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.socialIcon}
              src={facebook}
              alt="facebook"
            />
          </a>
          <a
            href={pinterestShare}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.socialIcon}
              src={pinterest}
              alt="pinterest"
            />
          </a>
        </div>
        <div className={styles.coverImageContainer}>
          {blogContent.coverImage ? (
            <img
              className={styles.coverImage}
              src={blogContent.coverImage}
              alt="cover post"
            />
          ) : <LoaderPage />}
        </div>
        {isButton && <a href={pinterestShare} target="_blank" rel="noopener noreferrer" className={styles.button}>
          <p className={styles.textButton}>{textButton}</p>
        </a>}
        <div dangerouslySetInnerHTML={{ __html: blogContent.body }} />
        {isButton && <a href={pinterestShare} target="_blank" rel="noopener noreferrer" className={styles.button}>
          <p className={styles.textButton}>{textButton}</p>
        </a>}
      </div>
      {otherBlogs.entries && (
        <div className={styles.EntriesContainer}>
          {newOthers.entries.map((item, idx) => (
            <MoreEntries
              key={`Post-${idx}`}
              {...item}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default BlogEntry
